// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"7620d876","318":"56e4a4a4","787":"085fda03"}[chunkId] + ".chunk.js";
};